module.exports = __webpack_public_path__ + "static/media/bnr_itsukie53de00be8da203b3e6d907a4664f08a.webp";